function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M4.273 0h7.454c1.486 0 2.025.155 2.568.445.543.29.97.717 1.26 1.26.29.543.445 1.082.445 2.568v7.454c0 1.486-.155 2.025-.445 2.568-.29.543-.717.97-1.26 1.26-.543.29-1.082.445-2.568.445H4.273c-1.486 0-2.025-.155-2.568-.445a3.029 3.029 0 01-1.26-1.26C.155 13.752 0 13.213 0 11.727V4.273c0-1.486.155-2.025.445-2.568.29-.543.717-.97 1.26-1.26C2.248.155 2.787 0 4.273 0z",
  id: "Clearbit_svg__23_a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "Clearbit_svg__24_b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#Clearbit_svg__23_a"
})), React.createElement("use", {
  fill: "#148CFC",
  xlinkHref: "#Clearbit_svg__23_a"
}), React.createElement("path", {
  fill: "#4DB1FD",
  mask: "url(#Clearbit_svg__24_b)",
  d: "M8 0h8v16H8z"
}), React.createElement("path", {
  fill: "#F2FAFE",
  mask: "url(#Clearbit_svg__24_b)",
  d: "M8 8h8v8H8z"
}));

var SvgClearbit = function SvgClearbit(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgClearbit;